import React from 'react';

const Hero = () => {
  return (
    <div id="home" className="relative bg-gradient-to-br from-navy via-slate-800 to-slate-900 text-white min-h-screen flex items-center pt-20">
      <div className="absolute inset-0 bg-black opacity-40"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="max-w-2xl mb-8 md:mb-0">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
              Elite Football Training in <span className="text-cyan">Central New Jersey</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-300 leading-relaxed">
              Specialized coaching for Quarterbacks, Running Backs, and Wide Receivers
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="#contact" 
                className="bg-cyan hover:bg-cyan-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 text-center shadow-lg"
              >
                Start Training
              </a>
              <a 
                href="#about" 
                className="border-2 border-white hover:bg-white hover:text-navy text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all text-center"
              >
                Learn More
              </a>
            </div>
          </div>
          
          <div className="w-full md:w-auto flex justify-center">
            <img 
              src="/TheLab.svg" 
              alt="The Lab Logo" 
              className="w-80 h-80 md:w-96 md:h-96 lg:w-[450px] lg:h-[450px] object-contain animate-pulse"
            />
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-4 md:bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg className="w-6 h-6 text-white" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
          <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </div>
    </div>
  );
};

export default Hero;
